import { startCase } from 'lodash';

import config from 'js/app/config';

import type { MergedDegreeDescriptionPageFields } from 'bundles/degree-description/contexts/DegreeDescriptionPageContext';

type PageInfoType = {
  pageName: string;
  pathName: string;
};

/**
 * These constants are used for our structured data markup, separately from our navigation items
 */
export const PAGE_NAMES_MARKUP = Object.freeze({
  overview: 'Overview',
  admissions: 'Admissions',
  academics: 'Academics',
  careers: 'Careers',
  tuitionFinancing: 'Tuition and Financing',
  studentExperience: 'Student Experience',
});

export const getProgramCategoryName = (programCategoryId?: string | null) => {
  if (!programCategoryId) return undefined;
  const categoryName = startCase(programCategoryId);
  return `${categoryName} Degrees`;
};

export const getProviderMarkupData = (pageContent: MergedDegreeDescriptionPageFields) => {
  return {
    '@type': 'CollegeOrUniversity',
    '@id': `${config.url.base}${pageContent?.partner?.partnerSlug}#institution`,
    name: pageContent?.partner?.partnerName,
  };
};

export const getBreadcrumbListMarkupData = (pageContent: MergedDegreeDescriptionPageFields, pageInfo: PageInfoType) => {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          name: 'Online Degrees',
          '@id': `${config.url.base}degrees`,
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          name: getProgramCategoryName(pageContent.programCategoryId),
          '@id': `${config.url.base}degrees/${pageContent.programCategoryId}`,
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          name: pageContent.programName,
          '@id': `${config.url.base}degrees/${pageContent.slug}`,
        },
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          name: pageInfo.pageName,
          '@id': `${config.url.base}${pageInfo.pathName}`,
        },
      },
    ],
  };
};

export const getCredentialCategoryMarkupData = () => {
  return {
    '@type': 'DefinedTerm',
    '@id': 'https://credreg.net/ctdl/terms/#MasterDegree',
    name: "Master's Degree",
    inDefinedTermSet: {
      '@type': 'DefinedTermSet',
      '@id': 'https://credreg.net/ctdl/terms/',
      name: 'Credential Transparency Description Language',
    },
  };
};
